export default {
      id: "oc-dashboard-consumption-percent-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-consumption-percent",
      toString: function () {
        return this.url;
      }
    }